export { default as Header } from './Header/Header';
export { default as Footer } from './Footer/Footer';
export { default as FetchList } from './FetchList/FetchList';
export { default as FetchUserInfo } from './FetchUserInfo/FetchUserInfo';
export { default as TalkRoom } from './TalkRoom/TalkRoom';
export { default as TcUpload } from './TcUpload/TcUpload';
export { default as TcPlayer } from './TcPlayer/TcPlayer';
// export { default as TcLive } from './TcLive/TcLive';
